/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import * as serviceDrivenViewers from "../../../Models/Core/ServiceDrivenViewers";
import * as fieldComponents from "../../../Models/Core/FieldComponents";
import {ObjectUtils} from "../../../Utils";
import React from "react";

import {useNormalizedFieldComponentName} from "../../../Hooks/FieldComponentHooks";
import {EmptyValue} from "../EmptyValue";

export const ActivityFeedValueDisplay = (props) => {
    const {
        value,
        data,
        fieldCustomData
    } = props;
    
    let fieldComponentName = useNormalizedFieldComponentName(props.fieldComponentName)
    
    // some default viewers for string and numbers
    if(!fieldComponentName) {
        if (ObjectUtils.IsString(value)) {
            fieldComponentName = 'TextFieldViewer';
        } else if (typeof value === 'number') {
            fieldComponentName = 'NumberFieldViewer';
        }
    }
    
    // LatLongFieldViewer is not supported :( 
    if(fieldComponentName === 'LatLongFieldViewer') {
        fieldComponentName = 'NumberFieldViewer';
    }
    
    if (fieldComponentName) {
        if (fieldComponentName.startsWith("ServiceDrivenFieldViewer")) {
            const serviceName = fieldComponentName.substring(fieldComponentName.indexOf('(') + 1, fieldComponentName.indexOf(')'));
            const ServiceDrivenViewer = serviceDrivenViewers[serviceName + 'Viewer'];
            if (!ServiceDrivenViewer) {
                console.log('Undefined ServiceDrivenViewer:', serviceName + 'Viewer');
                return "N/A";
            }
            return <ServiceDrivenViewer Value={value} Data={data} FieldCustomData={fieldCustomData}/>;
        } else {
            if (fieldComponents[fieldComponentName]) {
                const FieldComponent = fieldComponents[fieldComponentName];
                return <FieldComponent Value={value} Data={data} FieldCustomData={fieldCustomData}/>;
            } else {
                console.log('Undefined Viewer:', fieldComponentName + '');
            }
        }
    }
    
    console.log('bad Delta Field value', value, fieldComponentName);
    return "N/A";
};
